import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h10","key":"svg-1"}],["path",{"d":"M9 18h3","key":"svg-2"}],["path",{"d":"M19 15v6","key":"svg-3"}],["path",{"d":"M16 18h6","key":"svg-4"}]]

const IconFilter2Plus = createReactComponent('outline', 'filter-2-plus', 'Filter2Plus', __iconNode);

export default IconFilter2Plus;